import { render, staticRenderFns } from "./TheHCLegend.vue?vue&type=template&id=dbda0496&scoped=true&"
import script from "./TheHCLegend.vue?vue&type=script&lang=js&"
export * from "./TheHCLegend.vue?vue&type=script&lang=js&"
import style0 from "./TheHCLegend.vue?vue&type=style&index=0&id=dbda0496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbda0496",
  null
  
)

export default component.exports